<template>
  <div class="page-body">
    <div class="page-title">
      <div class="page-title-left">
        <el-button class="menu-btn" @click="$emit('openMenu')">
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
        </el-button>
        {{ $route.meta.title }}
      </div>
    </div>
    <div class="tasks">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <div class="user-avatar">
            <el-avatar
              src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"
            />

            <p class="user-avatar__name">
              {{ user.name }}
            </p>
          </div>
        </div>

        <el-descriptions
          title="Info"
          :column="1"
          direction="vertical"
          class="setting-descriptions"
        >
          <el-descriptions-item label="Email">
            {{ user.email }}
          </el-descriptions-item>
        </el-descriptions>

        <!-- #TODO: Call API -->
        <el-button type="danger" plain @click="logOut()">LogOut</el-button>
      </el-card>
    </div>
  </div>
</template>

<script>
import ApiAuth from "@/api/auth";
import ApiTask from "@/api/task";

import UserName from "@/components/Common/UserName.vue";

import _ from "lodash";
export default {
  data() {
    return {
      categoryList: [],
      user: {},

      isMobile: false,
      loading: false,
    };
  },
  components: {
    UserName,
  },
  methods: {
    logOut() {
      localStorage.removeItem("token");
      this.$router.push("/");
    },
  },
  mounted() {
    ApiAuth.getMe().then((responce) => {
      this.user = responce.data;
    });

    if (window.innerWidth <= 768) {
      this.isMobile = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.menu__logo {
  width: 90%;
  display: block;
  margin: 15px auto;
}

@media only screen and (max-width: 768px) {
  .menu__logo {
    width: 70%;
  }
}
</style>